// api.js

export const URL = 'https://api.uefprios.com';
//export const URL = 'http://localhost:8002';

export const login = async (cedula, password) => {
  try {
    // Hacemos la solicitud POST al servidor
    const response = await fetch(URL+'/login/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cedula: cedula, clave: password }), // Adaptamos los nombres de los parámetros para que coincidan con los que espera la API
    });

    // Obtenemos la respuesta de la API
    const data = await response.json();

    // Verificamos si la respuesta es exitosa
   if (response.ok) {
      // Guardamos el token y la información del usuario en el localStorage
      localStorage.setItem('access_token', data.access_token);
      localStorage.setItem('token_type', data.token_type);
      localStorage.setItem('user_id', data.id);
      localStorage.setItem('user_name', data.nombre);
      localStorage.setItem('user_cedula', data.cedula);
      localStorage.setItem('user_rol_id', data.rol_id);
      localStorage.setItem('user_rol', data.rol);

      return { success: true };
    } else {
      return { success: false, message: data.detail || 'Credenciales incorrectas' }; // Si la API responde con un error, mostramos el mensaje
    }
  } catch (error) {
    console.error('Error:', error);
    // Si hubo un problema de conexión o cualquier otro error, devolvemos un mensaje
    return { success: false, message: 'Hubo un problema con la conexión a la API' };
  }
};

export function useLogout() {
  return () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_id');
  };
}

// Función para crear un nuevo usuario
export const createUsuario = async (usuarioData) => {
  const token = localStorage.getItem('access_token'); // Recuperamos el token desde el localStorage
  if (!token) {
    return { success: false, status: 401, message: 'No se encontró el token de autenticación' };
  }

  try {
    const response = await fetch(URL+'/usuarios/', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,  // Enviamos el token en la cabecera de autorización
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(usuarioData), // Enviamos los datos del usuario
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, status: response.status, message: 'Usuario creado correctamente' };
    } else {
      return { success: false, status: response.status, message: data.detail || 'Error al crear el usuario' };
    }
  } catch (error) {
    return { success: false, status: '', message: 'Hubo un problema con la conexión a la API' };
  }
};

// Función para obtener los usuarios desde la API
export const getUsuarios = async () => {
  const token = localStorage.getItem('access_token');  // Recuperamos el token desde el localStorage

  if (!token) {
    return { success: false, status: 401, message: 'No se encontró el token de autenticación' };
  }

  try {
    const response = await fetch(URL + '/usuarios/', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, status: response.status, usuarios: data }; 
    } else {
      return { success: false, status: response.status, message: 'Error al obtener los usuarios' }; 
    }
  } catch (error) {
    return { success: false, status: '', message: 'Hubo un problema con la conexión a la API' };
  }
};

// Función para actualizar los datos de un usuario
export const updateUsuario = async (usuarioId, nombre, correo, clave, tipo_usuario_id) => {
  const token = localStorage.getItem('access_token'); // Recuperamos el token desde el localStorage

  if (!token) {
    return { success: false, message: 'No se encontró el token de autenticación' };
  }

  try {
    // Hacemos la solicitud PUT al servidor para actualizar los datos del usuario
    const response = await fetch(URL + `/usuarios/${usuarioId}/`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,  // Enviamos el token en la cabecera de autorización
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        nombre,
        correo,
        clave,
        tipo_usuario_id, // Enviamos el tipo de usuario que se seleccionó
      }),
    });

    // Obtenemos la respuesta de la API
    const data = await response.json();

    // Verificamos si la respuesta es exitosa
    if (response.ok) {
      return { success: true, message: 'Usuario actualizado correctamente' };
    } else {
      return { success: false, message: data.detail || 'Error al actualizar el usuario' }; // Si la API responde con un error
    }
  } catch (error) {
    console.error('Error:', error);
    // Si hubo un problema de conexión o cualquier otro error, devolvemos un mensaje
    return { success: false, message: 'Hubo un problema con la conexión a la API' };
  }
};

export const getPeriodos = async () => {
  const token = localStorage.getItem('access_token'); // Recuperamos el token desde el localStorage
  if (!token) {
    return { success: false, status: 401,  message: 'No se encontró el token de autenticación' };
  }

  try {
    const response = await fetch(URL + '/periodos/', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`, // Si tu API requiere autenticación
        'Content-Type': 'application/json',
      },
    });

    // Verificamos si la respuesta es exitosa
    if (response.ok) {
      // Convertimos la respuesta a JSON
      const data = await response.json();
      return { success: true, status: response.status, message: '', data: data };  // Retornamos los datos
    } else {
      // Si la respuesta no es exitosa, devolvemos el mensaje de error
      return { success: false, status: response.status, message: 'Error en la solicitud: ' + response.status };
    }
  } catch (error) {
    console.error('Error:', error);
    // Si hubo un problema de conexión o cualquier otro error, devolvemos un mensaje
    return { success: false, status: '', message: 'Hubo un problema con la conexión a la API' };
  }
};

export const getNivelesAsignaturas = async () => {
  const token = localStorage.getItem('access_token'); // Recuperamos el token desde el localStorage
  if (!token) {
    return { success: false, status: 401,  message: 'No se encontró el token de autenticación' };
  }

  try {
    const response = await fetch(URL + '/plan/', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`, // Si tu API requiere autenticación
        'Content-Type': 'application/json',
      },
    });

    // Verificamos si la respuesta es exitosa
    if (response.ok) {
      // Convertimos la respuesta a JSON
      const data = await response.json();
      return { success: true, status: response.status, message: '', data: data };  // Retornamos los datos
    } else {
      // Si la respuesta no es exitosa, devolvemos el mensaje de error
      return { success: false, status: response.status, message: 'Error en la solicitud: ' + response.status };
    }
  } catch (error) {
    console.error('Error:', error);
    // Si hubo un problema de conexión o cualquier otro error, devolvemos un mensaje
    return { success: false, status: '', message: 'Hubo un problema con la conexión a la API' };
  }
};

export const getAsignaturasPorCurso = async () => {
  const token = localStorage.getItem('access_token'); // Recuperamos el token desde el localStorage
  if (!token) {
    return { success: false, message: 'No se encontró el token de autenticación' };
  }

  try {
    const response = await fetch(URL + '/asignaturas/', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`, // Si tu API requiere autenticación
        'Content-Type': 'application/json',
      },
    });

    // Verificamos si la respuesta es exitosa
    if (response.ok) {
      // Convertimos la respuesta a JSON
      const data = await response.json();
      return data;  // Retornamos los datos
    } else {
      // Si la respuesta no es exitosa, devolvemos el mensaje de error
      return { success: false, message: 'Error en la solicitud: ' + response.status };
    }
  } catch (error) {
    console.error('Error:', error);
    // Si hubo un problema de conexión o cualquier otro error, devolvemos un mensaje
    return { success: false, message: 'Hubo un problema con la conexión a la API' };
  }
};

export const getCursosPorPeriodo = async (periodoId) => {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return { success: false, message: 'No se encontró el token de autenticación' };
  }

  try {
    const response = await fetch(URL + `/cursos/${periodoId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return { success: false, message: 'Error al cargar los cursos' };
    }
  } catch (error) {
    console.error('Error:', error);
    return { success: false, message: 'Hubo un problema con la conexión a la API' };
  }
};